import { render, staticRenderFns } from "./AdminRole.vue?vue&type=template&id=49b64e30&scoped=true"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"
import style0 from "./AdminRole.vue?vue&type=style&index=0&id=49b64e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b64e30",
  null
  
)

export default component.exports